(function () {
  function getPlayableSrc(video) {
    if (!video) return '';
    if (video.currentSrc) return video.currentSrc;
    const source = video.querySelector('source');
    return (source && source.getAttribute('src')) || video.getAttribute('src') || '';
  }

  function playMedia(video, src) {
    if (!video) return;

    if (src) {
      const current = getPlayableSrc(video);
      if (current !== src) {
        video.pause();
        video.removeAttribute('src');
        const existing = video.querySelector('source');
        if (existing) {
          existing.setAttribute('src', src);
          existing.setAttribute('type', 'video/mp4');
        } else {
          const source = document.createElement('source');
          source.src = src;
          source.type = 'video/mp4';
          video.appendChild(source);
        }
        video.load();
      }
    }

    video.muted = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('muted', '');

    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {});
    }
  }

  function initSection(root) {
    if (!root || root.dataset.bewoHowtoReady === 'true') return;
    root.dataset.bewoHowtoReady = 'true';

    let media = root.querySelector('[data-bewo-howto-media]');
    if (!media) media = root.querySelector('.bewo-howto__media-video');
    if (media && !media.hasAttribute('data-bewo-howto-media')) {
      media.setAttribute('data-bewo-howto-media', '');
    }

    const steps = Array.from(root.querySelectorAll('[data-bewo-howto-step]'));
    if (!media) return;

    const activateStep = (step) => {
      steps.forEach((other) => other.classList.toggle('is-active', other === step));
      const src = step.getAttribute('data-video-src');
      if (src) playMedia(media, src);
      else playMedia(media);
    };

    steps.forEach((step) => {
      step.addEventListener('click', () => activateStep(step));
      step.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          activateStep(step);
        }
      });
      step.setAttribute('role', 'button');
      step.setAttribute('tabindex', '0');
    });

    const firstWithVideo = steps.find((step) => step.getAttribute('data-video-src'));
    if (firstWithVideo) {
      activateStep(firstWithVideo);
    } else {
      playMedia(media);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-bewo-howto]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-bewo-howto]');
    if (root) {
      root.dataset.bewoHowtoReady = 'false';
      initSection(root);
    }
  });
})();
